import styled from "styled-components";
import colors from "../../assets/styles/colors";


export const CheckBoxShowOptionSelectedMessageError = styled.small`
  font-size: 12px;
  color: ${colors.bgDanger};
  line-height: 14px;
  margin: 5px 8px;
  opacity: ${prop => prop.error ? '1' : '0'};
  transition: ease-in-out .2s;
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  transition: ease-in-out .2s;
`;

export const CheckBoxLabel = styled.label`
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.03em;
  color: ${colors.textPrimary};
  margin-left: 8px;
  opacity: 0.9;
  text-transform: uppercase;
`;
